import axios from 'axios';

export default {
  createStripeCustomer(customerId) {
    const postData = {
      customer: {
        id: customerId,
      }
    }
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/payments/stripe/customers", postData)
      .then(results=>{
        return results.data;
      })
  },
  deletePaymentMethod (paymentMethodId) {
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/payments/methods/" + paymentMethodId)
      .then(results=>{
        return results.data;
      })
  },
  getCustomerPaymentMethods (customerId) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/payments/methods?customerId=" + customerId)
      .then(results=>{
        return results.data;
      })
  },
  getPayment(paymentId){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/payments/"+paymentId)
      .then(results=>{
        return results.data;
      })
  },
  setupPaymentIntent(postData){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/payments/intents/setup", postData)
      .then(results=>{
        return results.data;
      })
  },
  createStripePaymentIntent(postData){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/payments/intents", postData)
      .then(results=>{
        return results.data;
      })
  },
  processAdminPayment(payment, invoices){
    let body = {
      payment : {
        automatic : payment.automatic,
        type : payment.paymentMethod.code,
        amount : payment.amount,
        reference : payment.reference,
        description : payment.description,
        date : payment.date,
        customerId : payment.customerId,
        credit : payment.credit?payment.credit:undefined,
      },
      invoices
    }
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/payments",body)
      .then(results=>{
        return results.data;
      })
  },
  processPayment(paymentToken, refNumber,invoices, automatic, type,amount, billingDetails, profile){

    let body = {
      payment : {
        automatic,
        type,
        card : {
          paymentToken
        },
        amount,
        refNumber,
        // billingDetails : {zip : 'H1M3R5'},
        billingDetails,
        // profile,
        settleWithAuth:true
      },
      invoices
    }
    // console.log("PROCESS PAYMENT ", body);
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/payments",body)
      .then(results=>{
        return results.data;
      })
  },
  listPaymentMethods(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/payments/types",{params})
      .then(results=>{
        return results.data;
      })
  },
  delete(paymentId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/payments/"+paymentId)
      .then(results=>{
        return results.data;
      })
  },
  createCreditNote(creditNote){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes",creditNote)
      .then(results=>{
        return results.data;
      })
  },
  downloadQuickbooksExtractPaymentsCSV (filters, filename) {
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/payments/reports/QUICKBOOKS_EXPORT";
    let params  = filters;
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob(['\uFEFF', response.data], { type: 'text/csv; charset=utf-8' }));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename+'.csv'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },


}
